export const NOTIFICATIONS_PATH = "/notifications";
